<div class="justify-content-center additional-info-header m-b-25" translate>dimbo.i18n.vi.header</div>
<div class="straight-line m-b-25"></div>
<div mat-dialog-content style="box-shadow: none;">
    <ngx-spinner></ngx-spinner>
    <div class="container-box p-l-15">
        <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-input-text mat-custom-cal">
                    <mat-label translate>dimbo.i18n.label.registration</mat-label>
                    <input matInput [(ngModel)]="data.vehicleinfo.registration">
                </mat-form-field>
        </div>

        <br>

        <div class="row justify-content-center criteria-box">
                <mat-form-field class="mat-custom-cal" >
                    <input matInput [matDatepicker]="picker" [max]="maxDate"
                        [(ngModel)]="data.vehicleinfo.registrationDate" name="registrationDate"
                        [placeholder]=regdplaceholder disabled>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker disabled="false"></mat-datepicker>
                </mat-form-field>
        </div>

        <br>


        <div class="row justify-content-center criteria-box">
            <div class="col-sm-4">
                <mat-form-field class="float-left">
                    <mat-label translate>dimbo.i18n.label.currentMileage</mat-label>
                    <input matInput [(ngModel)]="data.vehicleinfo.mileageValue">
                </mat-form-field>
            </div>
            <div class="col-sm-8">
                <section class="example-section m-t-20 m-l-10 float-right">
                    <mat-radio-group [(ngModel)]="data.vehicleinfo.mileageUnit" [disabled]="isReset">
                        <mat-radio-button class="custom-font" value="km"><span translate>dimbo.i18n.km</span></mat-radio-button>
                        <mat-radio-button class="custom-font m-l-10" value="mi"><span translate>dimbo.i18n.miles</span></mat-radio-button>
                    </mat-radio-group>

                </section>
            </div>

        </div>
        <br>

        <!-- <div mat-dialog-actions> -->
        <div class="container m-b-15">
            <div class="row">

                <div class="col-sm-6">
                    <input class="float-left dialog-cancel-button dialog-cancel-button-text m-t-10" style="margin-left: -15px;" type="button" (click) = close() [value]="canceltranlation">
                </div>
                <div class="col-sm-6">
                    <input class="float-right dialog-button dialog-button-text m-r-10 m-t-10" style="padding-top: 3px;" type="button" (click)="updateVehicleInfo()" [value]="oktranlation">
                </div>

            </div>
        </div>
    </div>

</div>